import React from "react";

import * as S from "./styles";
import { ActivityPropType } from "./type";

const Alerts = ({
  activities,
  xAxis,
  yAxis,
  onClick,
  ...props
}: ActivityPropType) => {
  const [topEdge, bottomEdge] = yAxis.range();

  return (
    <g data-testid="alert-activities" {...props}>
      {activities.map(activity => {
        const x = xAxis(new Date(activity.created_at));
        return (
          <React.Fragment key={activity.id}>
            <S.AlertLine
              data-activityId={activity.id}
              className="activity-line"
              x1={x}
              y1={bottomEdge}
              x2={x}
              y2={topEdge}
              onClick={e => onClick?.(activity, e)}
            />
            <S.ActivityCircle cx={x} cy={bottomEdge} r={2} />
          </React.Fragment>
        );
      })}
    </g>
  );
};

export default React.memo(Alerts);
